import { useTranslation } from 'react-i18next'

import MainContentContainer from '@/components/layouts/MainContentContainer'
import Page from '@/components/layouts/Page'
import { ControllerBulkActionsHostComponent } from '@/features/controller/components/bulkActions/ControllerBulkActionsHostComponent'

export function ControllersPage() {
  const { t } = useTranslation()

  return (
    <Page
      pageHeaderProps={{
        pageTitle: `${t('controllers.title')}`,
        isRoot: true,
      }}
    >
      <MainContentContainer>
        <ControllerBulkActionsHostComponent />
      </MainContentContainer>
    </Page>
  )
}
